import React from 'react';
import {ViewNote, EditNote} from './Note';
import MessageDefinitions from '../i18n/MessageDefinitions';
import {FormattedMessage} from 'react-intl';
import FontAwesome from 'react-fontawesome';
import classnames from 'classnames';

class NotePanel extends React.Component {

  state = {
    notes: [],
    loading: false
  };

  addNote = () => {
    this.setState({
      notes: [
        ...this.state.notes,
        {
          id: Math.random(),
          content: '',
          editing: true,
          isNew: true
        }
      ]
    });
  };

  saveNote = (note, content) => {
    this.setState({
      loading: true
    });
    if (note.isNew) {
      window.ignite.noteService.addNote(content).then(() => {
        this.retrieveNotes();
      });
    } else {
      window.ignite.noteService.updateNote({
        ...note,
        content
      }).then(() => {
        this.retrieveNotes();
      });
    }
  };

  cancelClicked = note => {
    if (note.isNew) {
      this.setState({
        notes: [
          ...this.state.notes.filter(n => n.id !== note.id)
        ]
      });
    } else {
      this.retrieveNotes();
    }
  };

  editNote = note => {
    const notes = [...this.state.notes];
    notes.forEach(n => {
      if (note.id === n.id) {
        n.editing = true;
      }
    });
    this.setState({
      notes
    })
  };

  removeNote = note => {
    window.ignite.noteService.removeNote(note).then(() => {
      this.retrieveNotes();
    });
  };

  retrieveNotes = () => {
    this.setState({
      loading: true
    });
    window.ignite.noteService.retrieveNotes().then(notes => {
      this.setState({
        loading: false,
        notes
      });
    });
  };

  componentDidMount = () => {
    this.retrieveNotes();
  };

  render() {
    const {notes, loading} = this.state;
    const renderedNotes = notes.map(note => {
      return note.editing ?
        <EditNote note={note} key={note.id} onCancel={this.cancelClicked} onSave={this.saveNote}/> :
        <ViewNote note={note} key={note.id} onEdit={this.editNote} onRemove={this.removeNote}/>;
    });
    const classes = classnames({
      loading,
      'notes-panel': true
    });

    return <div className={classes}>
      {renderedNotes}
      <div className="text-center">
        <span className="btn btn-secondary new" onClick={this.addNote}>
          <FormattedMessage {...MessageDefinitions.addNote} />
          <FontAwesome name="plus"/>
        </span>
      </div>
    </div>;
  }
}

export default NotePanel;



/** WEBPACK FOOTER **
 ** ./src/main/js/notes/components/NotePanel.js
 **/